import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})
export class CmaService {

  constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }


  // searchCmaReport(pageNumber: any, pageRecords: number, fromDate: any, toDate: any, accountNumber: any): Observable<any> {
  //   let url = "";
  //   let filter = "";

  //   if (fromDate && fromDate !== "") {
  //     filter += `&fromDate=${encodeURIComponent(fromDate)}`;
  //   }

  //   if (toDate && toDate !== "") {
  //     filter += `&toDate=${encodeURIComponent(toDate)}`;
  //   }

  //   if (accountNumber && accountNumber !== "") {
  //     filter += `&accountNumber=${accountNumber}`;
  //   }

  //   url = `${API_URLBLAZE}/statement/report/cma?page_size=${pageRecords}&page_no=${pageNumber}` + filter;

  //   return this.http.post(url, {}).pipe(catchError(this.handleError()));
  // }

  searchStatement(pageNumber: any, pageRecords: number, fromDate: any, toDate: any, accountNumber: any): Observable<any> {
    let url = `${API_URLBLAZE}/statement/form/cma?`;
    let filter = "";

    if (fromDate && fromDate !== "") {
        filter += `fromDate=${fromDate}`;
    }

    if (toDate && toDate !== "") {
        if (filter.length > 0) filter += '&';
        filter += `toDate=${toDate}`;
    }

    if (accountNumber && accountNumber !== "") {
        if (filter.length > 0) filter += '&';
        filter += `accountNumber=${accountNumber}`;
    }

    url += filter;

    return this.http.post(url, "").pipe(
      catchError(this.handleError())
    );
}


  
  getStatement(pageNumber: any, pageRecords: number, fromDate: any, toDate: any, accountNumber: any): Observable<any> {
    let url = `${API_URLBLAZE}/statement/report/cma?page_size=${pageRecords}&page_no=${pageNumber}`;
  
    let filter = "";
    filter += `&sort_dir=DESC&sort_column=postedDateTime`;

    if (fromDate && fromDate !== "") {
      const fromDateTimestamp = new Date(fromDate).getTime();
      const toDateTimestamp = new Date(toDate).getTime();
      filter += `&rangeCondition=postedDateTime=${fromDateTimestamp},${toDateTimestamp}`;
    }
  
    if (accountNumber && accountNumber !== "") {
      filter += `&accountNumber=${accountNumber}`;
    }
      url += filter;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  
  ExportStatments(pageNumber: any, pageRecords: number, fromDate: any, toDate: any, accountNumber: any): Observable<any> {
    let url = `${API_URLBLAZE}/statement/report/cma/export?`;
   // let url = `http://localhost:8097/statement/report/cma/export?`;

    let filter = "";
    filter += `&sort_dir=DESC&sort_column=postedDateTime`;

    if (fromDate && fromDate !== "") {
      const fromDateTimestamp = new Date(fromDate).getTime();
      const toDateTimestamp = new Date(toDate).getTime();
      filter += `&rangeCondition=postedDateTime=${fromDateTimestamp},${toDateTimestamp}`;
    }
  
    if (accountNumber && accountNumber !== "") {
      filter += `&accountNumber=${accountNumber}`;
    }
      url += filter;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }


  searchRequest(pageNumber: any, pageRecords: number) {  
      let url = `${API_URLBLAZE}/statement/form?page_size=${pageRecords}&page_no=${pageNumber}+&sort_dir=DESC&sort_column=createdOn`;
      return this.http.get(url).pipe(catchError(this.handleError()));
  }
  
  getAccounts(){
    let url = "";
    url = `${API_URLBLAZE}/statement/report/accounts`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      if (error.status == 401) {
        this.storageService.clean()
        this.router.navigate(['/auth/login']);
      }
      result = error?.error;
      return of(result as T);
    };
  }

}
